import React from 'react';
import { Box, Container, Typography, Link as MuiLink, Stack, Divider } from '@mui/material';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        mt: 'auto',
        py: { xs: 3, sm: 3 },
        px: 2,
        bgcolor: '#f8f9fa',
        borderTop: '1px solid rgba(0,0,0,0.08)',
      }}
    >
      <Container maxWidth="lg">
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          justifyContent="space-between"
          alignItems="center"
          spacing={{ xs: 2, sm: 2 }}
        >
          {/* Logo and Copyright */}
          <Box sx={{ textAlign: { xs: 'center', sm: 'left' } }}>
            <Typography
              variant="body2"
              sx={{
                fontWeight: 600,
                color: 'primary.main',
                fontSize: '0.9rem',
                lineHeight: 1.3,
              }}
            >
              Guest Stream
            </Typography>
            <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.75rem' }}>
              © {currentYear} Guest Stream. All rights reserved.
            </Typography>
          </Box>

          {/* Legal Links */}
          <Stack
            direction="row"
            spacing={{ xs: 1.25, sm: 1.5 }}
            divider={<Divider orientation="vertical" flexItem sx={{ my: 0.25, borderColor: 'rgba(0,0,0,0.12)' }} />}
            sx={{
              alignItems: 'center',
              flexWrap: 'wrap',
              justifyContent: 'center',
              rowGap: 1,
            }}
          >
            {[
              { to: '/team', label: 'Team' },
              { to: '/terms', label: 'Terms of Service' },
              { to: '/privacy', label: 'Privacy Policy' },
            ].map((link) => (
              <MuiLink
                key={link.to}
                component={Link}
                to={link.to}
                sx={{
                  color: 'text.secondary',
                  textDecoration: 'none',
                  fontSize: { xs: '0.8125rem', sm: '0.8rem' },
                  lineHeight: 1.5,
                  py: 0.25,
                  '&:hover': {
                    color: 'primary.main',
                    textDecoration: 'underline',
                  },
                }}
              >
                {link.label}
              </MuiLink>
            ))}
            <MuiLink
              href="mailto:will@guest.stream"
              sx={{
                color: 'text.secondary',
                textDecoration: 'none',
                fontSize: { xs: '0.8125rem', sm: '0.8rem' },
                lineHeight: 1.5,
                py: 0.25,
                '&:hover': {
                  color: 'primary.main',
                  textDecoration: 'underline',
                },
              }}
            >
              Contact
            </MuiLink>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
};

export default Footer;
